import { Group, Progress } from "@mantine/core";
import { useAppSelector } from "../app/hooks";

const AlgoProcessBar: React.FC = () => {
  const countAlgosSpace = useAppSelector((state) => state.design.countAlgosSpace);

  const getPercenteageeComplete = () => {
    return (countAlgosSpace.complete / (countAlgosSpace.total - countAlgosSpace.failed)) * 100;
  };

  return (
    <div>
      <Group p={5} grow w="100%" gap="xs" bg="white">
        <Progress
          style={{ width: "100%" }}
          my="xs"
          size="xl"
          color={getPercenteageeComplete() < 100 ? "#f8992e" : "green"}
          animated={getPercenteageeComplete() < 100}
          value={getPercenteageeComplete()}
        >
          <h4>
            {countAlgosSpace.complete} rom klare av {countAlgosSpace.total - countAlgosSpace.failed}
          </h4>
        </Progress>
      </Group>
    </div>
  );
};

export default AlgoProcessBar;